"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCarSelectionFilter = void 0;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var filterSlice_1 = require("../redux/slice/filterSlice");
var selectors_1 = require("../redux/selectors");
var react_router_dom_1 = require("react-router-dom");
var useCarSelectionFilter = function (_a) {
    var filterKey = _a.filterKey, title = _a.title, isOpen = _a.isOpen, onToggle = _a.onToggle;
    var dispatch = (0, react_redux_1.useDispatch)();
    var filterRef = react_1.default.useRef(null);
    var _b = react_1.default.useState(false), isInitialized = _b[0], setIsInitialized = _b[1];
    var searchParams = (0, react_router_dom_1.useSearchParams)()[0];
    var _c = (0, react_redux_1.useSelector)(selectors_1.filtersSelector).values, brand_name = _c.brand_name, model_name = _c.model_name, year_from = _c.year_from, max_price = _c.max_price, owners_count = _c.owners_count, engine_name_type_name = _c.engine_name_type_name, generation_name = _c.generation_name, gearbox_type_id = _c.gearbox_type_name, body_type_id = _c.body_type_name, drive_type_id = _c.drive_type_name;
    react_1.default.useEffect(function () {
        if (!isInitialized) {
            var urlValue = searchParams.get(filterKey);
            if (urlValue) {
                dispatch((0, filterSlice_1.setFilterValue)({ key: filterKey, value: urlValue }));
            }
            setIsInitialized(true);
        }
    }, [dispatch, filterKey, isInitialized, searchParams]);
    var getCurrentValue = react_1.default.useCallback(function () {
        switch (filterKey) {
            case 'brand_name':
                return brand_name || title;
            case 'model_name':
                return model_name || title;
            case 'generation_name':
                return generation_name || title;
            case 'year_from':
                return year_from || title;
            case 'max_price':
                return max_price || title;
            case 'engine_name_type_name':
                return engine_name_type_name || title;
            case 'gearbox_type_name':
                return gearbox_type_id || title;
            case 'body_type_name':
                return body_type_id || title;
            case 'drive_type_name':
                return drive_type_id || title;
            case 'owners_count':
                return owners_count || title;
            default:
                return title;
        }
    }, [
        filterKey,
        title,
        brand_name,
        model_name,
        generation_name,
        year_from,
        max_price,
        engine_name_type_name,
        gearbox_type_id,
        body_type_id,
        drive_type_id,
        owners_count,
    ]);
    var handleClick = react_1.default.useCallback(function () {
        onToggle(filterKey);
    }, [onToggle, filterKey]);
    var handleSelectItem = react_1.default.useCallback(function (item) {
        dispatch((0, filterSlice_1.setFilterValue)({ key: filterKey, value: item }));
        var filterParams = {};
        if (brand_name)
            filterParams.brand_name = brand_name;
        if (model_name)
            filterParams.model_name = model_name;
        if (generation_name)
            filterParams.generation_name = generation_name;
        if (year_from)
            filterParams.year_from = year_from;
        if (max_price)
            filterParams.max_price = max_price;
        if (engine_name_type_name)
            filterParams.engine_name_type_name = engine_name_type_name;
        if (gearbox_type_id)
            filterParams.gearbox_type_name = gearbox_type_id;
        if (body_type_id)
            filterParams.body_type_name = body_type_id;
        if (drive_type_id)
            filterParams.drive_type_name = drive_type_id;
        if (owners_count)
            filterParams.owners_count = owners_count;
        filterParams[filterKey] = item;
        dispatch((0, filterSlice_1.loadFilters)(filterParams));
        onToggle(filterKey);
    }, [
        dispatch,
        filterKey,
        onToggle,
        brand_name,
        model_name,
        generation_name,
        year_from,
        max_price,
        engine_name_type_name,
        gearbox_type_id,
        body_type_id,
        drive_type_id,
        owners_count,
    ]);
    react_1.default.useEffect(function () {
        var handleClickOutside = function (event) {
            if (filterRef.current && !filterRef.current.contains(event.target) && isOpen) {
                onToggle(filterKey);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () { return document.removeEventListener('mousedown', handleClickOutside); };
    }, [isOpen, onToggle, filterKey]);
    return {
        filterRef: filterRef,
        getCurrentValue: getCurrentValue,
        handleClick: handleClick,
        handleSelectItem: handleSelectItem,
    };
};
exports.useCarSelectionFilter = useCarSelectionFilter;
